<template>
  <!-- MDFE拦截提醒 -->
  <div class="Box">
    <el-card class="mb5">
      <el-form class="form_class">
        <el-row
          :gutter="24"
          type="flex" justify="left"
          style="flex-wrap: wrap;align-items: end"
        >
          <el-col :span="6">
            <el-form-item>
              <el-select
                v-model="chooseNumber"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                size="small"
                class="orderNumClass"
                @change="changeNum"
              >
                <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" /><!-- 安骏运单号 -->
                <el-option key="2" :label="$t('collectionCenter.ScanNumber')" :value="2" /><!-- 扫描单号 -->
                <el-option key="3" :label="$t('collectionCenter.BagNumber')" :value="3" /><!-- 袋号 -->
              </el-select>
              <el-input
                v-model="orderNumber"
                :placeholder="$t('collectionCenter.max200Line')"
                clearable type="textarea" :rows="1"
                style="width: 100%"
                @blur="BlockNewNumber"
                @keydown.enter.native="BlockNewNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- MDFE密钥 -->
            <el-form-item :label="$t('collectionCenter.mdfeKey')">
              <el-input
                v-model="queryForm.params.mdfeKey"
                clearable size="small" style="width: 100%"
                :placeholder="$t('collectionCenter.pleaseInput')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 扫描时间 -->
            <el-form-item :label="$t('collectionCenter.scanTime')">
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('collectionCenter.EndTime')"
                :range-separator="$t('collectionCenter.to')"
                :start-placeholder="$t('collectionCenter.StartTime')"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                size="small"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--操作网点-->
            <el-form-item :label="$t('collectionCenter.OperationSite')">
              <el-select
                v-model="queryForm.params.siteId"
                :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
                clearable filterable size="small"
                style="width: 100%"
                remote reserve-keyword
                :remote-method="remoteGetSiteList"
                @clear="remoteGetSiteList"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 扫描环节 -->
            <el-form-item :label="$t('collectionCenter.scanningStage')">
              <el-select
                v-model="queryForm.params.scanType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                size="small" style="width: 100%"
              >
                <el-option
                  v-for="item in scanTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--操作人-->
            <el-form-item :label="$t('collectionCenter.operator')">
              <el-select
                v-model="queryForm.params.userId"
                :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
                clearable filterable size="small"
                remote reserve-keyword
                :remote-method="getOperator"
                style="width: 100%;"
                @clear="getOperator"
              >
                <el-option
                  v-for="(item, index) in operatorList"
                  :key="index"
                  :label="item.realName + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin: 16px auto; text-align: left">
              <el-button size="mini" type="primary" @click="searchClick">
                {{ $t('operationCenter.Procurar') }}
              </el-button><!-- 搜索 -->
              <el-button size="mini" type="info" @click="resetClick">
                {{ $t('collectionCenter.reset') }}
              </el-button><!-- 重置 -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-button size="mini" type="success" @click="downloadAll">
        {{ $t('collectionCenter.allExport') }}
      </el-button><!-- 全部导出 -->
      <el-table
        :data="tableDate"
        :max-height="600"
        border
        style="margin-top: 20px"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" type="index"
          width="60"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- 安骏运单号 -->
        <el-table-column :label="$t('orderCenterCont.anjunWaybillNumber')" prop="waybillNumber" align="center" />
        <!-- 扫描单号 -->
        <el-table-column :label="$t('collectionCenter.ScanNumber')" prop="scanOrderNumber" align="center" />
        <!-- 袋号 -->
        <el-table-column :label="$t('collectionCenter.BagNumber')" prop="bagNumber" align="center" />
        <!-- MDFE密钥 -->
        <el-table-column :label="$t('collectionCenter.mdfeKey')" prop="mdfeKey" align="center" />
        <!-- 扫描时间 -->
        <el-table-column :label="$t('collectionCenter.scanTime')" prop="scanTime" align="center" />
        <!-- 扫描环节 -->
        <el-table-column :label="$t('collectionCenter.scanningStage')" prop="scanTypeName" align="center" />
        <!-- 操作网点 -->
        <el-table-column :label="$t('collectionCenter.OperationSite')" prop="scanSiteName" align="center" />
        <!-- 操作人 -->
        <el-table-column :label="$t('collectionCenter.operator')" prop="scanUser" align="center" />
      </el-table>
      <div class="right">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="searchClick1"
          @size-change="searchClick"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { siteFuzzyQuery } from '@/api/lanshou';
import { getUserPage } from '@/api/user';
import { clsLogsPage, clsLogsExportAll } from '@/api/messageCenter';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  name: 'MdfeAlert',
  data() {
    return {
      scanTypeList: [
        { value: null, label: this.$t('collectionCenter.tudo') },
        { value: 1, label: this.$t('collectionCenter.truckLoading') }, // 装车
        { value: 2, label: this.$t('GlobalSetObj.arrive') }, // 到件
        { value: 3, label: this.$t('routes.manualConsolidation') }, // 手工集包
        { value: 4, label: this.$t('collectionCenter.sortingMachine') } // 分拣机
      ],
      orderNumber: '',
      chooseNumber: 1,
      timeValue: [],
      siteList: [],
      operatorList: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startTime: '',
          endTime: '',
          bagNumberList: [],
          waybillNumberList: [],
          scanOrderNumberList: [],
          mdfeKey: null,
          siteId: null,
          scanType: null,
          userId: null
        }
      },
      tableDate: [],
      total: 0
    };
  },
  created() {
    this.default();
  },
  methods: {
    resetClick() {
      this.default();
    },
    default() {
      this.orderNumber = '';
      this.chooseNumber = 1;
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params = {
        startTime: dayjs(d).startOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00'),
        endTime: dayjs(d).endOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00'),
        bagNumberList: [],
        waybillNumberList: [],
        scanOrderNumberList: [],
        mdfeKey: null,
        siteId: null,
        scanType: null,
        userId: null
      };
      this.remoteGetSiteList('');
      this.getOperator('');
      this.searchClick();
    },
    changeNum() {
      this.orderNumber = '';
      this.queryForm.params.bagNumberList = [];
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanOrderNumberList = [];
    },
    BlockNewNumber() {
      this.$nextTick(() => {
        if (this.orderNumber) {
          let lines = this.orderNumber
            .split('\n')
            .filter(line => line && line.trim())
            .map(line => line.replace(/\s/g, '').trim());
          if (lines.length > 200) {
            lines = lines.slice(0, 200);
            this.$message.warning(this.$t('collectionCenter.intercept200'));
          }
          this.orderNumber = lines.join('\n');
          if (this.chooseNumber === 1) {
            // 安骏运单号
            this.queryForm.params.waybillNumberList = lines;
          }
          if (this.chooseNumber === 2) {
            // 扫描单号
            this.queryForm.params.scanOrderNumberList = lines;
          }
          if (this.chooseNumber === 3) {
            // 袋号
            this.queryForm.params.bagNumberList = lines;
          }
        } else {
          this.queryForm.params.bagNumberList = [];
          this.queryForm.params.waybillNumberList = [];
          this.queryForm.params.scanOrderNumberList = [];
        }
      });
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.startTime = '';
        this.queryForm.params.endTime = '';
        return;
      }
      dayjs.extend(utc);
      dayjs.extend(timezone);
      this.queryForm.params.startTime = dayjs(val[0]).format('YYYY-MM-DDTHH:mm:ss+08:00');
      this.queryForm.params.endTime = dayjs(val[1]).format('YYYY-MM-DDTHH:mm:ss+08:00');
    },
    // 获取操作网点数据
    remoteGetSiteList(val = '') {
      siteFuzzyQuery(val).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 获取操作人数据
    getOperator(name = '') {
      const queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          realName: name
        }
      };
      getUserPage(queryForm).then(res => {
        if (res.code === 200) {
          this.operatorList = res.data.records;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    searchClick() {
      this.queryForm.pageNumber = 1;
      this.searchClick1();
    },
    searchClick1() {
      clsLogsPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableDate = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    downloadAll() {
      if (this.tableDate.length <= 0) {
        // '无可导出数据'
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
        return;
      }
      clsLogsExportAll(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.orderNumClass ::v-deep .el-input__inner {
  font-size: 14px;
  color: #606266;
  font-weight: 700;
}
.form_class ::v-deep .el-form-item {
  margin-bottom: 10px !important;
}
</style>
